var render, staticRenderFns
import script from "./NotificationToast.vue?vue&type=script&lang=ts&"
export * from "./NotificationToast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec30c5",
  null
  
)

export default component.exports